export default function configureRoutes(routes, sidebarConfig, $stateProvider) {
    for (const routeName in routes) {
        const views:any = {};

        const routeData = routes[routeName]

        if (routeData.template) {
            views.content = {
                template: routeData.template
            }
        } else {
            views.content = {
                templateUrl: routeData.templateUrl ? routeData.templateUrl : (routeData.url ? routeData.url + '.html' : routeData)
            }
        }


        if ((routeData.sidebarTemplateUrl) && (routeData.sidebar !== false)) {
            views.rightbar = { templateUrl: routeData.sidebarTemplateUrl };
        } else if ((routeData.sidebarTemplate) && (routeData.sidebar !== false)) {
            views.rightbar = { template: routeData.sidebarTemplate };
        } else if (routeData.sidebar) {
            var url = routeData.templateUrl;
            var separator = url.lastIndexOf("/");
            var dot = url.lastIndexOf(".html");
            var name = url.substring(separator + 1, dot);
            name += (sidebarConfig.sufix + '.html');
            url = sidebarConfig.url + '/' + name;

            views.rightbar = { templateUrl: url };
        };

        $stateProvider = $stateProvider.state(routeName, {
            url: (routeData.url ? routeData.url : routeData),
            params: routeData.params,
            views: views,
            resolve: routeData.resolve,
            sidebar: routeData.sidebar
        });
    }
}